/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type UseRemoveScheduleFromDisplays_ScheduleFragment = { __typename: 'Schedule', id: string, removingDisplays: Array<{ __typename: 'Display', id: string }> };

export type RemoveScheduleFromDisplaysMutationVariables = Types.Exact<{
  input: Types.ScheduleRemoveDisplaysInput;
}>;


export type RemoveScheduleFromDisplaysMutation = { __typename: 'Mutation', scheduleRemoveDisplays: { __typename: 'ScheduleRemoveDisplaysPayload', displays: Array<{ __typename: 'Display', id: string, schedule?: { __typename: 'DisplaySchedule', schedule?: { __typename: 'Schedule', id: string, title: string, removingDisplays: Array<{ __typename: 'Display', id: string }> } | null } | null }> } };

export const UseRemoveScheduleFromDisplays_ScheduleFragmentDoc = gql`
    fragment useRemoveScheduleFromDisplays_schedule on Schedule {
  id
  removingDisplays: displays(filter: {state: REMOVING}) {
    id
  }
}
    `;
export const RemoveScheduleFromDisplaysDocument = gql`
    mutation RemoveScheduleFromDisplays($input: ScheduleRemoveDisplaysInput!) {
  scheduleRemoveDisplays(input: $input) {
    displays {
      id
      schedule {
        schedule {
          id
          title
          ...useRemoveScheduleFromDisplays_schedule
        }
      }
    }
  }
}
    ${UseRemoveScheduleFromDisplays_ScheduleFragmentDoc}`;
export type RemoveScheduleFromDisplaysMutationFn = ApolloReactCommon.MutationFunction<RemoveScheduleFromDisplaysMutation, RemoveScheduleFromDisplaysMutationVariables>;

/**
 * __useRemoveScheduleFromDisplaysMutation__
 *
 * To run a mutation, you first call `useRemoveScheduleFromDisplaysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveScheduleFromDisplaysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeScheduleFromDisplaysMutation, { data, loading, error }] = useRemoveScheduleFromDisplaysMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveScheduleFromDisplaysMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveScheduleFromDisplaysMutation, RemoveScheduleFromDisplaysMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveScheduleFromDisplaysMutation, RemoveScheduleFromDisplaysMutationVariables>(RemoveScheduleFromDisplaysDocument, options);
      }
export type RemoveScheduleFromDisplaysMutationHookResult = ReturnType<typeof useRemoveScheduleFromDisplaysMutation>;
export type RemoveScheduleFromDisplaysMutationResult = ApolloReactCommon.MutationResult<RemoveScheduleFromDisplaysMutation>;
export type RemoveScheduleFromDisplaysMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveScheduleFromDisplaysMutation, RemoveScheduleFromDisplaysMutationVariables>;